module.exports = __webpack_public_path__ + "img/Cordelia_Schmid.e1594291.jpg";